module.exports = __webpack_public_path__ + "images/img-z0Lu8Wa.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/10.png
// module id = 2347
// module chunks = 0